import { network } from 'services/network';

export const getAiSubTaskMitigation = (params) => {
    return network.post('api/bo/chat/getAiSubTaskMitigation', params).then((response) => {
        return response.data;
    });
};
